export namespace IncidentsNotificationTypes {
    export const INCIDENT_ZENTRALE_NOTIFICATION = 'INCMAN.ZENTRALE';
    export const INCIDENT_ABTEILUNG_NOTIFICATION = 'INCMAN.ABTEILUNG';
    export const INCIDENT_DELEGATION_NOTIFICATION = 'INCMAN.DELEGATION';
    
}

